import { Injectable, OnInit } from '@angular/core';
import { IApplicantLoginResponse } from '../interfaces/IApplicantLoginResponse';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';
import { map } from 'rxjs/operators';
import { IGetOperationResponse } from '../interfaces/IGetOperationResponse';
import { DataSharingService } from './DataSharing.service';
import { IOptionSetItem } from '../interfaces/IOptionSetItem';
import { NgxIndexedDBService } from 'ngx-indexed-db';


@Injectable({
  providedIn: 'root'
})
export class UserConfigService implements OnInit {

  private _userType: string;
  private _userId: string;
  private _isOwner: boolean;
  private _isApplicant: boolean;
  private _userCpr;
  private _isLoggedIn: boolean = false;
  private _isEkey2: boolean = false;
  private _isEkey: boolean = false;
  private _userName = new BehaviorSubject<string>("");
  private _chosenModule: number;
  private _loggedInModule: any;
  private _IdleTimeoutValue: number;
  private _TokenExpiryTime: number;
  private _InactivityTimeValueForAutomaticLogout: number
  cast = this._userName.asObservable();
  private _isBoth: boolean;
  baseUrl: string;

  public static MTTModulesEn: IOptionSetItem[] = [
    {
      Label: 'Land Services',
      Value: 1
    },
    {
      Label: 'Air Transport Directorate',
      Value: 2
    },
    {
      Label: 'Post Regulatory Authority',
      Value: 3
    },
    {
      Label: 'Aeronautical Licensing Directorate',
      Value: 4
    }
  ];

  public static MTTModulesAr: IOptionSetItem[] = [
    {
      Label: 'النقل البرى',
      Value: 1
    },
    {
      Label: 'مديرية النقل الجوي',
      Value: 2
    },
    {
      Label: 'تنظيم قطاع البريد',
      Value: 3
    },
    {
      Label: 'مديرية ترخيص الطيران',
      Value: 4
    }
  ];

  ngOnInit(): void {
    let userName = this.getUserName();
    this._userName = new BehaviorSubject<string>(userName);
    this._isEkey = JSON.parse(this.appConfig.getAppConfig().IsEKey);
    console.log("isEKey = " + this._isEkey);
    this._isEkey2 = JSON.parse(this.appConfig.getAppConfig().IsEKey2);
    console.log("isEKey2  = " + this._isEkey2);
  }
  constructor(private translateService: TranslateService,
    private http: HttpClient,
    private appConfig: AppConfigService,
    private dbService: NgxIndexedDBService,
    private sharedDataService: DataSharingService) {
    this.appConfig.getAppConfigForCommonService().subscribe(data => {
      if (data)
        this.baseUrl = data.AppUrl;
    });
  }
  getUserType() {
    if (!this._userType) {
      this.sharedDataService.userType.subscribe(value => {
        this._userType = value;
      });
    }
    return this._userType;
  }
  getChosenModule() {
    debugger;
    if (!this._chosenModule) {
      this.dbService.getAll('userLoginsDB').then(
        loggedInUsers => {
          if (loggedInUsers && loggedInUsers.length > 0 && loggedInUsers[0]['ChosenModule']) {
            let lastChosenModule = loggedInUsers[0]['ChosenModule'];
            this._chosenModule = lastChosenModule || {};
          }
        }, error => console.log(error)
      );
      if (!this._chosenModule) {
        this.sharedDataService.choosenModule.subscribe(value => {
          this._chosenModule = value;
        });
      }
    }
    return this._chosenModule;
  }

  setUserConfig(
    userType: string,
    applicantName: string,
    englishUserName: string,
    arabicUserName: string,
    accessToken: string,
    chosenModule: number,
    IdleTimeoutValue,
    TokenExpiryTime,
    InactivityTimeValueForAutomaticLogout) {
    debugger;
    this._userType = userType;
    this._isLoggedIn = true;
    this._chosenModule = chosenModule == null ? 4 : chosenModule;
/*
    if (this._isEkey2) {
      this._TokenExpiryTime = 600;
      this._IdleTimeoutValue = 600;
    } else {
      this._TokenExpiryTime = (TokenExpiryTime - 1) * 60;
      this._IdleTimeoutValue = IdleTimeoutValue;
    }
*/
    this._TokenExpiryTime = (TokenExpiryTime - 1) * 60;
    this._IdleTimeoutValue = IdleTimeoutValue;
    this._InactivityTimeValueForAutomaticLogout = InactivityTimeValueForAutomaticLogout;

    sessionStorage.setItem("EnglishUserName", englishUserName);
    sessionStorage.setItem("ArabicUserName", arabicUserName);
    sessionStorage.setItem("ApplicantName", applicantName);
    sessionStorage.setItem("Access-Token", accessToken);
    this.sharedDataService.isUserLoggedIn.next(true);
    this.sharedDataService.userName.next(this.getUserName());
    this.sharedDataService.userType.next(this._userType);
    this.sharedDataService.choosenModule.next(this._chosenModule);
    this.sharedDataService.idleTimeoutValue.next(this._IdleTimeoutValue);
    this.sharedDataService.tokenExpiryTimeValue.next(this._TokenExpiryTime);
    this.sharedDataService.InactivityTimeValueForAutomaticLogout.next(this._InactivityTimeValueForAutomaticLogout);

  }
  // setLoggenInUserRole(isOwner: boolean, isApplicant: boolean, isBoth: boolean) {
  //   this._isOwner = isOwner;
  //   this._isApplicant = isApplicant;
  //   this._isBoth = isBoth;

  //   if (this._isOwner) {
  //     sessionStorage.setItem('userRole', "1");
  //   }
  //   if (this._isApplicant) {
  //     sessionStorage.setItem('userRole', "2");
  //   }
  //   if (this._isBoth) {
  //     sessionStorage.setItem('userRole', "3");
  //   }
  // }
  // isOwner(){
  //   if(this._isOwner)
  //   return
  // }
  // isOwner() {
  //   if (sessionStorage.getItem("userRole") == "1") {
  //     this._isOwner = true;
  //   }
  //   return this._isOwner;
  // }

  // isapplicant() {
  //   if (sessionStorage.getItem("userRole") == "2") {
  //     this._isApplicant = true;
  //   }
  //   return this._isApplicant;
  // }
  // isApplicantOwner() {
  //   if (sessionStorage.getItem("userRole") == "3") {
  //     this._isBoth = true;
  //   }
  //   return this._isBoth;
  // }
  isLoggedIn() {
    return this._isLoggedIn;
  }


  updateUserName() {
    this.sharedDataService.userName.next(this.getUserName());
  }


  getUserName(): string {
    let userName: string = "";
    if (this.translateService.currentLang == "en") {
      userName = sessionStorage.getItem("EnglishUserName");
    } else {
      userName = sessionStorage.getItem("ArabicUserName");
    }
    return userName;
  }


  checkIfUserIsLoggedIn(url) {
    return this.http.get<object>(url + '/api/UserDataManager/CheckIfAccessTokenIsStillValid')
      .pipe(
      // catchError(this.handleError('',))
    );

    // return this.http.get(this.baseUrl + '/api/UserDataManager/CheckIfAccessTokenIsStillValid').pipe(map((response: IGetOperationResponse<boolean>) => {
    //   if (response && response.Result) {
    //     this._isLoggedIn = true;
    //     this.sharedDataService.isUserLoggedIn.next(true);
    //   }
    // }));
  }

  GetUserInfo(url) {

    return this.http.get<object>(url + '/api/UserDataManager/GetUserInformation')
      .pipe(
      // catchError(this.handleError('',))
    );
  }

  refreshAccessToken() {

    return this.http.get<object>(this.baseUrl + '/api/UserDataManager/GetAccessToken')
      .pipe(
      // catchError(this.handleError('',))
    );
  }
  logOut() {
    // location.reload();
    window.location.href = "/home"
    localStorage.clear();
    sessionStorage.clear();
    this.updateUserName();
    // this.router.navigateByUrl('/login');
    // this.router.navigate(['/login']);

  }
  getIdleTimeoutValue() {
    return this._IdleTimeoutValue;
  }
  getTokenExpiryTimeValue() {
    if (!this._TokenExpiryTime) {
      this.sharedDataService.tokenExpiryTimeValue.subscribe(value => {
        this._TokenExpiryTime = value;
      });
    }
    return this._TokenExpiryTime;
  }

}
